import { BaseApiService } from './BaseApiService';

export class BudgetService extends BaseApiService {
  constructor() {
    super();
    this.api = this.instance;
    this.base = '/budget';
  }

  async monitoringPeriods() {
    const { data } = await this.api.get(
      [this.base, 'monitoring-periods'].join('/'),
      {
        params: {},
      },
    );
    return data.map(x => {
      return { value: x.id, description: x.period };
    });
  }

  async monitoringPeriodYears() {
    const { data } = await this.api.get(
      [this.base, 'monitoring-period-years'].join('/'),
      {
        params: {},
      },
    );
    return data.map(x => {
      return {
        // value as concatenation of yearId and budgetMonitoringPeriodId
        // in order to keep the old generateParams implementation
        value: [x.id, x.budget_monitoring_period_id].join('_'),
        description: x.year,
      };
    });
  }

  async pbaPeriods() {
    const { data } = await this.api.get([this.base, 'pba-periods'].join('/'), {
      params: {},
    });

    return data.map(x => {
      return { value: x.id, description: x.period };
    });
  }

  async years() {
    const { data } = await this.api.get([this.base, 'years'].join('/'), {
      params: {},
    });
    if (data.length)
      return data.map(x => {
        return { value: x.id, description: x.year };
      });

    return [];
  }

  budget({ name, value }) {
    const filterTypeMap = {
      years: 0,
      pbaPeriods: 1,
      monitoringPeriods: 2,
    };

    const filterMap = {
      years: 'year_id',
      pbaPeriods: 'pba_period_id',
      monitoringPeriods: 'budget_monitoring_period_id',
    };

    const generateParams = () => {
      if (name === 'monitoringPeriods')
        return {
          filtering_type: filterTypeMap[name],
          [filterMap[name]]: value?.split('_')[1],
          [filterMap['years']]: value?.split('_')[0],
        };
      return {
        filtering_type: filterTypeMap[name],
        [filterMap[name]]: value,
      };
    };

    return this.api.get([this.base].join('/'), {
      params: generateParams(),
    });
  }
}
